<template>
    <div class="card-gif block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_gallery-sm.png" alt="">
                        </div>

                        <h4>GIF</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <label >Title</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.text"-->
<!--                            :error="!data.text"-->
<!--                            :error-messages="!data.text? 'Title is Required':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.text" :type="'textfield'"
                                           :validationRules="autocompleteGifTitleValidationRules"></vTextareaAutocomplete>
                    <label >Subtitle</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.subtitle"-->
<!--                            :error="!data.subtitle"-->
<!--                            :error-messages="!data.subtitle? 'Subtitle is Required':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.subtitle" :type="'textfield'"
                                           :validationRules="autocompleteGifSubtitleValidationRules"></vTextareaAutocomplete>
                    <label >URL</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.url"-->
<!--                            :error="!data.url || !common.validURL(data.url)"-->
<!--                            :error-messages="!data.url? 'URL is Required':'' || !common.validURL(data.url)? 'URL is not valid':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.url" :type="'textfield'"
                                           :validationRules="autocompleteGifUrlValidationRules"></vTextareaAutocomplete>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    export default {
        name: "card-gif",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {

                    }
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common,
                autocompleteGifTitleValidationRules: [
                    v => !!v || 'Title is Required'
                ],
                autocompleteGifSubtitleValidationRules: [
                    v => !!v || 'Subtitle is Required'
                ],
                autocompleteGifUrlValidationRules: [
                    v => !!v || 'Url is Required'
                ]
            }
        },
        mounted() {

        },
        methods: {

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>